import React, { useContext } from 'react';
import { KaEmployeeTemplate } from '../UserAccess/KaEmployeeTemplate';
import { UserTemplate } from '../UserAccess/UserTemplate';
import NavPageLink from './NavPageLink'
import { useKaEmployee } from '../UserAccess/useKaEmployee';
import { LoginType, UserContext } from '../UserAccess/UserContext';
import { SidebarContext } from './SidebarContext';

const KaEmployeeLinks = () => {
  const employee = useKaEmployee();

  return <>
    <NavPageLink
      businessNotRequired
      defaultPath="/employee/business"
      linkDisplayText="Businesses" />
    {employee.canViewNotifications &&
      <NavPageLink
        businessNotRequired
        defaultPath="/employee/siteNotifications"
        linkDisplayText="Site Notifications" />}
    {employee.canViewSiteStatus &&
      <NavPageLink
        businessNotRequired
        defaultPath="/employee/sitesStatus"
        linkDisplayText="Sites Status" />}
    {employee.canViewOrders &&
      <NavPageLink
        defaultPath="/employee/orders"
        linkDisplayText="Orders" />}
    {employee.canViewIntegrations &&
      <NavPageLink
        defaultPath="/employee/integrations"
        linkDisplayText="Integrations" />}
  </>
}

export function NavSideMenu() {
  const { user } = useContext(UserContext);
  const { isCollapsed, toggleSidebar } = useContext(SidebarContext);
  const showDataSharing = user?.userType === LoginType.User
    ? user.selectedBusiness?.usesDataSharing
    : false;

  return <nav className={`navbar navbar-expand-sm navbar-sidebar navbar-vertical navbar-light bg-white border-bottom border-end${isCollapsed ? ' sidebar-collapsed-nav' : ''}`}>
    {!isCollapsed && <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#sideNavbar" aria-controls="sideNavbar" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-default">
        <i className="bi-list"></i>
      </span>
      <span className="navbar-toggler-toggled">
        <i className="bi-x"></i>
      </span>
    </button>}
    <div className="collapse navbar-collapse navbar-sidebar-aside-body" id="sideNavbar">
      <button
        className="btn btn-ghost-secondary btn-icon mb-1"
        onClick={toggleSidebar}
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}>
        <i className={`bi-${isCollapsed ? 'layout-sidebar' : 'layout-sidebar-inset'}`}></i>
      </button>
      <ul className="navbar-nav nav nav-vertical nav-tabs nav-tabs-borderless">
        <KaEmployeeTemplate>
          <KaEmployeeLinks />
        </KaEmployeeTemplate>
        <UserTemplate>
          <NavPageLink
            defaultPath="/"
            iconName="speedometer2"
            linkDisplayText="Dashboard" />
          <NavPageLink
            defaultPath="/reports"
            iconName="file-text"
            linkDisplayText="Reports" />
          <NavPageLink
            defaultPath="/branches"
            iconName="geo-alt"
            linkDisplayText="Branches" />
          <NavPageLink
            defaultPath="/customers"
            iconName="people"
            linkDisplayText="Customers" />
          <NavPageLink
            defaultPath="/drivers"
            iconName="people"
            linkDisplayText="Drivers" />
          <NavPageLink
            defaultPath="/orders"
            iconName="file-ruled"
            linkDisplayText="Orders" />
          <NavPageLink
            defaultPath="/orderTransactions"
            iconName="file-earmark-ruled"
            linkDisplayText="Order Transactions" />
          <NavPageLink
            defaultPath="/purchaseOrders"
            iconName="file-ruled"
            linkDisplayText="Purchase Orders" />
          <NavPageLink
            defaultPath="/products"
            iconName="diagram-3"
            linkDisplayText="Products" />
          {showDataSharing &&
            <NavPageLink
              defaultPath="/sharedproducts"
              iconName="link-45deg"
              linkDisplayText="Shared Products" />}
          <NavPageLink
            defaultPath="/recipes"
            iconName="diagram-3"
            linkDisplayText="Recipes" />
          <NavPageLink
            defaultPath="/transports"
            iconName="truck"
            linkDisplayText="Transports" />
          <NavPageLink
            defaultPath="/carriers"
            iconName="truck"
            linkDisplayText="Carriers" />
          <NavPageLink
            defaultPath="/applicators"
            iconName="truck"
            linkDisplayText="Applicators" />
        </UserTemplate>
      </ul>
    </div>
    <div data-testid="logo-container" className={`position-fixed bottom-0 start-0${isCollapsed ? ' d-flex justify-content-center' : ''}`} style={{ width: isCollapsed ? '4.5rem' : '17rem' }}>
      <a href="https://www.kahlerautomation.com" target="_blank" rel="noreferrer" aria-label="Logo" title="Kahler Automation">
        <img className={`m-2${isCollapsed ? '' : ' d-none'}`} src="/KA-RGB-color_logo-minimized.png" alt="Minimized Logo" style={{ width: '3.5rem' }} />
        <img className={`m-2${isCollapsed ? ' d-none' : ''}`} src="/KA-RGB-color_logo.png" alt="Logo" width='100' style={{ minWidth: '15rem', maxWidth: '15rem' }} />
      </a>
    </div>
  </nav>
}
